






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StationStatus } from '@/services/api.service';

export enum MelosPlayerStatus {
  PLAYING = 'playing',
  PAUSED = 'paused',
  STOPPED = 'stopped',
}

@Component
export default class MelosPlayer extends Vue {
  @Prop() private audioPlayerSource!: string | undefined;
  @Prop() private token!: string | undefined;
  private playerTime: number = 0;
  private playerStatus: MelosPlayerStatus = MelosPlayerStatus.STOPPED;

  private mounted() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    audioPlayer.onerror = (error: any) => {
      this.checkPlayerStatus();
    };
    audioPlayer.onpause = () => {
      this.checkPlayerStatus();
    };
    audioPlayer.onplay = () => {
      this.checkPlayerStatus();
    };
    audioPlayer.ontimeupdate = () => {
      this.onPlayerTimeUpdate();
    };
  }

  @Watch('targetElapsedTime')
  private onStationStatusChanged() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    audioPlayer.currentTime = this.targetElapsedTime;
  }

  @Watch('audioPlayerSource')
  private onPlayerSourceChanged() {
    this.refreshAudioPlayer();
    if (this.playerStatus !== MelosPlayerStatus.PLAYING) {
      this.$store.commit('setPlayerData', { targetStatus: MelosPlayerStatus.PLAYING });
    }
  }

  private get trackDuration() {
    return this.$store.state.player?.trackDuration || 0;
  }

  private refreshAudioPlayer() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    audioPlayer.load();
    setTimeout(() => audioPlayer.currentTime = this.targetElapsedTime, 1000);
  }

  private checkPlayerStatus() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    if (audioPlayer?.ended) {
      this.playerStatus = MelosPlayerStatus.STOPPED;
    } else if (audioPlayer?.paused) {
      this.playerStatus = MelosPlayerStatus.PAUSED;
      this.$store.commit('setPlayerData', {
        targetStatus: MelosPlayerStatus.PAUSED,
        targetElapsedTime: audioPlayer.currentTime,
      });
    } else {
      audioPlayer.currentTime = this.targetElapsedTime;
      this.playerStatus = MelosPlayerStatus.PLAYING;
    }
    this.$emit('onStatusUpdate', this.playerStatus);
    if (this.playerStatus === MelosPlayerStatus.STOPPED) {
      this.handlePlayerStopped();
    }
  }

  private handlePlayerStopped() {
    if (this.$store.state.player?.loop) {
      const audioPlayer: any = this.$refs.audioPlayer as any;
      audioPlayer.currentTime = 0;
      this.$store.commit('setPlayerData', { targetElapsedTime: 0 });
      audioPlayer.play();
    } else {
      this.$emit('refresh');
    }
  }

  private async onPlayerTimeUpdate() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    this.playerTime = audioPlayer?.currentTime || 0;
    this.$store.commit('setPlayerData', {
      currentElapsedTime: this.playerTime,
    });
  }

  private isPlayerReady(): boolean {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    return audioPlayer?.readyState === 4;
  }

  private get targetElapsedTime(): number {
    return Math.floor(Number(this.$store.state.player?.targetElapsedTime || 0));
  }

  private get targetPlayerStatus(): MelosPlayerStatus {
    return this.$store.state.player?.targetStatus;
  }

  private get fullAudioSource(): string | undefined {
    if (this.token !== undefined && this.token !== '') {
      return `${this.audioPlayerSource}&access_token=${this.token}`;
    } else {
      return this.audioPlayerSource;
    }
  }

  @Watch('targetPlayerStatus')
  private onTargetPlayerStatusChanged() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    switch (this.targetPlayerStatus) {
      case MelosPlayerStatus.PLAYING:
        /* Media source is not yet ready */
        if (this.audioPlayerSource === undefined) {
          setTimeout(this.onTargetPlayerStatusChanged, 500);
          return;
        }
        audioPlayer.play()
        .catch((exception: any) => {
          this.checkPlayerStatus();
          let targetStatus = MelosPlayerStatus.PLAYING;
          if (this.playerStatus !== MelosPlayerStatus.PLAYING) {
            targetStatus = MelosPlayerStatus.PAUSED;
          }
          this.$store.commit('setPlayerData', {
            targetStatus,
          });
        });
        break;
      case MelosPlayerStatus.PAUSED:
        audioPlayer.pause();
        break;
      default:
        break;
    }
  }

  @Watch('playerStatus')
  private onPlayerStatusChanged() {
    this.$store.commit('setPlayerData', { currentStatus: this.playerStatus });
  }

  private togglePlayState() {
    const audioPlayer: any = this.$refs.audioPlayer as any;
    if (audioPlayer.paused) {
      audioPlayer.play();
    } else {
      audioPlayer.pause();
    }
  }

}
